// src/pages/MedicationManagement.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Widgets from '../components/WidgetTiles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const MedicationManagement = () => (
  <>
    <Header />
    <div id="content" role="main" className="home">
      {/* Interior Header */}
      <div id="interior-header-container" className="container-fluid">
        <div className="container">
          <h1>Medication Management</h1>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container py-5">

        {/* Top Section with Image */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <h2><strong>Treating Patients since 2013</strong></h2>
            <p>
              Psychiatric medication management is where Redemption Psychiatry started. While primary care physicians and family doctors can handle many simple cases, and facilities exist for intensive psychiatric care, there is substantial gap in-between. Redemption fills this gap by providing the best outpatient psychiatric care there is, treating even the toughest cases.
            </p>
          </div>
          <div className="col-md-6">
            <LazyLoadImage
              src="/img/med-patient.jpg"
              alt="Medication Management"
              className="img-fluid"
              style={{ borderRadius: '30px' }}
            />
          </div>
        </div>

        {/* How it Works */}
        <div className="row mb-5">
          <div className="col-md-12">
            <h2>How it Works</h2>
            <p>
              At Redemption Psychiatry, it all starts with your first phone call. Our team will get your information, send you your intake paperwork, and schedule your first appointment. Your provider (usually a psychiatrist or psychiatric nurse practitioner) will review your paperwork before hand, so your first appointment can be spent focusing on who you really are. You'll work together to establish a treatment plan, and schedule follow ups based on your progress to make sure your care is exactly what you need. No matter who you are or what you're struggling with, Redemption will pair you with a provider that specializes in what you need to make sure that you get the best care possible.
            </p>
          </div>
        </div>

        {/* Other Services */}
        <div className="row mb-5">
          <div className="col-md-12">
            <h2>Other Services</h2>
            <p>
              Redemption Psychiatry offers telehealth follow-ups, genetic testing to determine what medications will work best with your unique biology, and a suite of other services such as TMS, Ketamine, and Cognitive Testing to make sure you get the best treatments possible. Our focus is on giving you less appointments, and more progress.
            </p>
          </div>
        </div>

        {/* Costs and Coverage */}
        <div className="row mb-4">
          <div className="col-md-12">
            <h2>Costs and Coverage</h2>
            <p>
              Redemption Psychiatry takes all major health insurances, allowing you to get care at an affordable price. Currently Redemption Psychiatry does not accept Medicare or Medicaid. We also are dedicated to providing discounts and probono options for those in need. Call or sign up today to determine if your insurance is covered!
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <a href="/newpatients" className="button blue">Schedule Online</a>
              <a href="/contact" className="button blue">Call Our Intake Department</a>
            </div>
          </div>
        </div>

        {/* Referrals */}
        <div className="row mb-5">
          <div className="col-md-12">
            <h2>Referrals</h2>
            <p>
              Although we are happy to be your primary psychiatric health care provider, we understand that finding a psychiatrist who is the right fit for you can be challenging. While it is ideal to receive medication management at the same clinic where you receive advanced treatments like TMS and ketamine, this is not always possible. In these situations, we will coordinate care with your psychiatrist during your treatment for the best possible outcome. Redemption Psychiatry is one of the largest and most well-known private psychiatric practices in Arizona. We work hard to maintain good relationships with all our colleagues to enhance communication to promote improved outcomes.
            </p>
          </div>
        </div>

        {/* Looking for More Than Medication */}
        <div className="row mb-5">
          <div className="col-md-12">
            <h2>Looking for More than Medication?</h2>
            <p>
              If you are looking for relief that lasts, explore TMS and Ketamine, 2 treatments that help patients find relief without relying on medication management!
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <a href="/tms" className="button blue">Learn More About TMS</a>
              <a href="/ketamine" className="button blue">Learn More About Ketamine</a>
            </div>
          </div>
        </div>

        {/* Widgets */}
        <Widgets />
      </div>
    </div>
    <Footer />
  </>
);

export default MedicationManagement;
